import { useEffect } from "react";

let lockCount = 0;
let savedScrollY = 0;
let savedStyles = null;

function applyBodyScrollLock() {
  lockCount += 1;
  if (lockCount > 1) return;

  savedScrollY = window.scrollY || window.pageYOffset || 0;
  const body = document.body;
  const html = document.documentElement;

  savedStyles = {
    bodyOverflow: body.style.overflow,
    bodyPosition: body.style.position,
    bodyTop: body.style.top,
    bodyLeft: body.style.left,
    bodyRight: body.style.right,
    bodyWidth: body.style.width,
    htmlOverflow: html.style.overflow,
  };

  body.style.overflow = "hidden";
  html.style.overflow = "hidden";
  body.style.position = "fixed";
  body.style.top = `-${savedScrollY}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";
}

function releaseBodyScrollLock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0 || !savedStyles) return;

  const body = document.body;
  const html = document.documentElement;

  body.style.overflow = savedStyles.bodyOverflow;
  body.style.position = savedStyles.bodyPosition;
  body.style.top = savedStyles.bodyTop;
  body.style.left = savedStyles.bodyLeft;
  body.style.right = savedStyles.bodyRight;
  body.style.width = savedStyles.bodyWidth;
  html.style.overflow = savedStyles.htmlOverflow;

  window.scrollTo(0, savedScrollY);
  savedStyles = null;
}

/**
 * Prevents the page behind a modal/sheet from scrolling while `locked` is true.
 * Uses a ref-count so nested overlays (e.g. session + exercise dialogs) stay safe.
 */
export function useBodyScrollLock(locked = false) {
  useEffect(() => {
    if (!locked) return undefined;
    applyBodyScrollLock();
    return () => releaseBodyScrollLock();
  }, [locked]);
}
